import React from 'react';
import { Modal, Space, Button } from 'tt-ui-lib/core';
import styles from './LeaveAlert.module.scss';

const leaveIcon = (
  <svg
    width="176"
    height="176"
    viewBox="0 0 176 176"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_8370_7111)">
      <path
        d="M31.4462 172.546H145.241C146.173 172.546 146.968 171.342 146.968 169.961V4.4551C146.968 3.0581 146.173 1.8811 145.241 1.8811H31.4462C30.9292 1.8811 30.547 2.15335 30.2747 2.5851C30.2747 2.5851 30.2747 2.6181 30.2362 2.6456L30.173 2.74185C29.9007 3.13235 29.7192 3.6851 29.7192 4.4551V169.958C29.7192 171.344 30.514 172.546 31.4462 172.546Z"
        fill="#D0D1D2"
      />
      <path d="M0.750732 165.523H175.238V176.429H0.750732V165.523Z" fill="#D0D1D2" />
      <path
        d="M37.6943 176.413H139.205C140.036 176.413 140.745 175.208 140.745 173.825V8.34635C140.745 6.94935 140.036 5.76685 139.205 5.76685H37.6943C37.235 5.76685 36.8913 6.04185 36.652 6.47085C36.652 6.47085 36.6493 6.50385 36.6135 6.53685C36.6135 6.53685 36.5915 6.58635 36.5585 6.6386C36.3138 7.01535 36.1543 7.57635 36.1543 8.34635V173.844C36.1543 175.23 36.861 176.432 37.6943 176.432"
        fill="#3C9662"
      />
      <path
        d="M43.4445 176.523H134.816C135.564 176.523 136.199 175.357 136.199 174.012V13.3843C136.199 12.0286 135.567 10.8818 134.816 10.8818H43.4445C43.0347 10.8818 42.7212 11.1513 42.5067 11.5693C42.5067 11.5693 42.504 11.5996 42.4737 11.6298C42.4737 11.6298 42.4517 11.6821 42.4215 11.7288C42.2015 12.1001 42.0585 12.6446 42.0585 13.3843V174.004C42.0585 175.351 42.6937 176.514 43.4445 176.514"
        fill="#41A56E"
      />
      <path
        d="M50.2123 78.408H87.4281C87.7416 78.408 87.9973 78.012 87.9973 77.5445V21.9148C87.9973 21.4445 87.7416 21.0513 87.4281 21.0513H50.2096C50.0446 21.0513 49.9153 21.142 49.8301 21.285C49.8301 21.285 49.8191 21.2905 49.8191 21.3043L49.7971 21.3373C49.6868 21.5088 49.6347 21.7113 49.6486 21.9148V77.5445C49.6541 78.0148 49.9098 78.408 50.2123 78.408ZM48.3588 167.09H85.5718C85.8908 167.09 86.1411 166.669 86.1411 166.174V107.759C86.1411 107.269 85.8908 106.843 85.5718 106.843H48.3561C48.1911 106.843 48.0591 106.939 47.9738 107.099C47.9738 107.099 47.9628 107.11 47.9628 107.121C47.9628 107.121 47.9518 107.132 47.9408 107.154C47.8301 107.336 47.7782 107.549 47.7923 107.762V166.174C47.7923 166.667 48.0508 167.09 48.3588 167.09Z"
        fill="#3C9662"
      />
      <path
        d="M52.0768 154.742H81.8565C82.1123 154.742 82.3158 154.423 82.3158 154.069V110.753C82.3158 110.385 82.1123 110.077 81.8565 110.077H52.0795C52.0163 110.077 51.9541 110.094 51.8998 110.126C51.8455 110.159 51.8011 110.205 51.7715 110.261L51.766 110.283C51.766 110.283 51.755 110.289 51.7495 110.305C51.6698 110.401 51.6285 110.55 51.6285 110.753V154.082C51.623 154.432 51.832 154.753 52.0768 154.753"
        fill="#55C688"
      />
      <path
        d="M94.1875 167.09H131.4C131.719 167.09 131.97 166.669 131.97 166.174V107.759C131.97 107.269 131.719 106.843 131.4 106.843H94.1847C94.0197 106.843 93.8877 106.939 93.7997 107.099C93.7997 107.099 93.7887 107.11 93.7887 107.121C93.7887 107.121 93.7777 107.132 93.7667 107.154C93.6573 107.337 93.6055 107.549 93.6182 107.762V166.174C93.6237 166.667 93.8795 167.09 94.1875 167.09Z"
        fill="#3C9662"
      />
      <path
        d="M97.9 154.742H127.68C127.935 154.742 128.136 154.423 128.136 154.069V110.753C128.136 110.385 127.935 110.077 127.68 110.077H97.9C97.8368 110.077 97.7749 110.094 97.7207 110.127C97.6665 110.159 97.6221 110.206 97.592 110.261L97.5865 110.283C97.5865 110.283 97.5755 110.289 97.57 110.305C97.493 110.401 97.449 110.55 97.449 110.753V154.082C97.449 154.432 97.6552 154.753 97.9 154.753"
        fill="#55C688"
      />
      <path
        d="M57.8874 101.783C63.9307 101.783 68.8297 96.9911 68.8297 91.0799C68.8297 85.1688 63.9307 80.377 57.8874 80.377C51.8442 80.377 46.9452 85.1688 46.9452 91.0799C46.9452 96.9911 51.8442 101.783 57.8874 101.783Z"
        fill="#DBC926"
      />
      <path
        d="M57.8875 99.451C62.6139 99.451 66.4455 95.7032 66.4455 91.08C66.4455 86.4568 62.6139 82.709 57.8875 82.709C53.161 82.709 49.3295 86.4568 49.3295 91.08C49.3295 95.7032 53.161 99.451 57.8875 99.451Z"
        fill="#FBED21"
      />
      <path
        d="M52.9925 71.0215H84.6588C84.9255 71.0215 85.1428 70.6805 85.1428 70.2817V22.957C85.1428 22.5555 84.9255 22.22 84.6588 22.22H52.9815C52.9152 22.2198 52.8501 22.2383 52.7937 22.2733C52.7373 22.3083 52.6919 22.3584 52.6625 22.418C52.6625 22.418 52.6515 22.4262 52.6515 22.44L52.635 22.4702C52.5498 22.572 52.5085 22.737 52.5085 22.957V70.2817C52.5085 70.6805 52.7258 71.0215 52.9815 71.0215"
        fill="#55C688"
      />
      <path
        d="M94.1875 78.408H131.406C131.72 78.408 131.975 78.012 131.975 77.5445V21.9148C131.975 21.4445 131.72 21.0513 131.406 21.0513H94.1848C94.0198 21.0513 93.8933 21.142 93.8053 21.285C93.8053 21.285 93.7943 21.2905 93.7943 21.3043L93.7723 21.3373C93.6632 21.5093 93.6113 21.7114 93.6238 21.9148V77.5445C93.6293 78.0148 93.885 78.408 94.1875 78.408Z"
        fill="#3C9662"
      />
      <path
        d="M96.965 71.0215H128.634C128.901 71.0215 129.118 70.6805 129.118 70.2817V22.957C129.118 22.5555 128.901 22.22 128.634 22.22H96.9568C96.8904 22.2198 96.8253 22.2383 96.7689 22.2733C96.7125 22.3083 96.6671 22.3584 96.6378 22.418C96.6378 22.418 96.6268 22.4262 96.6268 22.44L96.6103 22.4702C96.5278 22.572 96.4838 22.737 96.4838 22.957V70.2817C96.4838 70.6805 96.6983 71.0215 96.954 71.0215"
        fill="#55C688"
      />
    </g>
    <defs>
      <clipPath id="clip0_8370_7111">
        <rect width="176" height="176" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const LeaveAlert = ({ open, setOpen, externalLink }) => {
  const onCancel = () => {
    setOpen(false);
  };

  return (
    <Modal open={open} onCancel={onCancel} title="You're leaving TransparenTerra">
      <Space direction="vertical" className={styles.contentWrapper}>
        <div className={styles.imgWrapper}>{leaveIcon}</div>

        <div className={styles.text}>
          You are being directed to an external site. If you trust this link, click on it below to
          proceed.
        </div>

        <a href={externalLink} target="_blank" rel="noopener noreferrer">
          {externalLink}
        </a>

        <Button onClick={onCancel}>Go back</Button>
      </Space>
    </Modal>
  );
};

export default LeaveAlert;
